// This is component is meant to show a large message on a page
// after the user has completed an action. It has a `type` prop,
// but it only supports 'success' right now. We’ll have to make
// changes once we want another type.

import React from 'react';

import styles from './PageMessage.scss';

import CheckIcon from 'Components/Button/check.svg';

const PageMessage = ({ type, title, text }) => {
  return (
    <div className="PageMessage">
      <div className="PageMessage__icon-container">
        <CheckIcon className="PageMessage__icon" />
      </div>
      <div className="PageMessage__title">{title}</div>
      {text ? <div className="PageMessage__text">{text}</div> : null}
    </div>
  );
};

export default PageMessage;
